module.exports = __webpack_public_path__ + "static/img/top-title.36370ac5.png";